import { styled, Card, Typography } from '@mui/material';
import { theme } from 'assets/themes/zizzi';

const cardBgColor = theme.palette.neutral.light;
const borderColor = theme.palette.secondary.main;

interface CardProps {
  highlight?: string;
}

export const StyledCard = styled(Card)<CardProps>`
  background-color: ${cardBgColor};
  ${({ highlight }) => highlight === 'true' && `border: solid 3px ${borderColor};`}
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0;
  user-select: none;
  -webkit-touch-callout: none;

  img {
    -webkit-user-drag: none;
    border-top-left-radius: ${theme.radius.sm};
    border-top-right-radius: ${theme.radius.sm};
    transition: opacity 0.3s ease-in, transform 0.3s ease-in;
  }

  &:hover {
    cursor: pointer;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);

    @media (hover: hover) {
      img {
        transform: scale(1.1);
      }
    }
  }
`;

export const Footer = styled('div')`
  align-items: center;
  background: white;
  border-bottom-left-radius: ${theme.radius.sm};
  border-bottom-right-radius: ${theme.radius.sm};
  display: flex;
  flex: 1;
  justify-content: space-between;
  padding: 0.5rem;
  position: relative;
  transition: background-color 0.3s ease-in;
  z-index: 1;

  .MuiTypography-root {
    line-height: 1.3;
  }

  ${theme.breakpoints.up('md')} {
    padding: 8px;
  }
`;

export const Text = styled(Typography)`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  overflow: hidden;
  padding-right: 1rem;
`;
